import React from 'react';
import './LoadingScreen.css';

const LoadingScreen = () => {
  return (
    <div className="loader">
      <div className="loader-logo">Seth Mr. Sanwariya<br />Agro Primes</div>
      <div className="loader-sub">Exporting India's Finest</div>
      <div className="loader-bar">
        <div className="loader-fill"></div>
      </div>
    </div>
  );
};

export default LoadingScreen;
